function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Map } from '@googlemaps/react-wrapper';
import { Image, Skeleton } from "antd";
import { Container, Row, Col } from 'react-bootstrap';
import { GoogleMap, Marker, useLoadScript, useJsApiLoader } from "@react-google-maps/api";
import { useMemo } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EventMap = function EventMap() {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    map = _React$useState2[0],
    setMap = _React$useState2[1];
  var center = useMemo(function () {
    return {
      lat: 18.52043,
      lng: 73.856743
    };
  }, []);
  var onLoad = React.useCallback(function callback(map) {
    // This is just an example of getting and using the map instance!!! don't just blindly copy!
    var bounds = new window.google.maps.LatLngBounds(center);
    map.fitBounds(bounds);
    setMap(map);
  }, []);
  var onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);
  var _useJsApiLoader = useJsApiLoader({
      id: 'google-map-script',
      googleMapsApiKey: "AIzaSyCciyo0us1dD_wHLl-p_9oM-ZCCasZgvkw"
    }),
    isLoaded = _useJsApiLoader.isLoaded;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Container, {
      style: {
        marginTop: "75px"
      },
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          children: /*#__PURE__*/_jsx(Image, {
            width: "100%",
            src: "drawables/2.png",
            preview: false,
            style: {
              borderRadius: "7px ",
              marginBottom: "10px"
            }
          })
        })
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          children: /*#__PURE__*/_jsx("div", {
            children: !isLoaded ? /*#__PURE__*/_jsx(Skeleton, {
              active: true
            }) : /*#__PURE__*/_jsx(GoogleMap, {
              mapContainerClassName: "map-container",
              mapContainerStyle: {
                width: '100%',
                height: '450px',
                borderRadius: "9px"
              },
              center: center,
              onLoad: onLoad,
              onUnmount: onUnmount,
              zoom: 10
            })
          })
        })
      })]
    })
  });
};
export default EventMap;